import React from 'react';
import {Typography} from '@mui/material';
import Wrapper from 'Components/Wrapper';
import globalSpacing from 'Theme/Spacing';
import Strings from 'Utils/constants/Strings';

const Texts = {...Strings.NoMemberData};

const NoMemberData = () => {
  return (
    <Wrapper>
      <Typography
        data-testid="no-member-data-text"
        variant="h6"
        p={globalSpacing.md}
        textAlign={'center'}>
        {Texts.PleaseSearchForMember}
      </Typography>
    </Wrapper>
  );
};

export default NoMemberData;
